<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">ITEM CATEGORY</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formHardwareTypeActive=!formHardwareTypeActive">ADD NEW
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formHardwareTypeActive">
						<div class="row p-3 mx-2 bg-white shadow">
							
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">TYPES OF GOODS<span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newHardwareType.hardware_type_name"/>
							</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
						
								<label class="d-block">CATEGORY <span style="color:red;">*</span></label>
								<smart-select 
									:options="CategoryTypeOptions"
									:reduce="option => option.value"  
									v-model="newHardwareType.category"
									placeholder="-- Pilih Jenis --"
									name="category"
								/>

							</div>
						</div> -->
						<!-- Select Category -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">CATEGORY <span style="color:red;">*</span></label>

								<!-- Pakai <select> dulu untuk debug -->
								<select
								v-model="newHardwareType.category"
								class="form-control w-100 rounded"
								name="category"
								>
								<option value="">-- Pilih Jenis --</option>
								<option v-for="opt in CategoryTypeOptions" :key="opt.value" :value="opt.value">
									{{ opt.label }}
								</option>
								</select>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newHardwareTypeSaved">
									<div class="alert alert-success" role="alert">
										Successfully Saved New Device Type.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewHardwareType">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">{{ createErrorMessage }}</p>
										</div>
										<div v-for="err in errorHardwareTypeList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">
												{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewHardwareType">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewHardwareType">Submit
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
						<datatable :currentIdx="currentPage" :datas="hardwaretypes" :structure="hardwaretypeTableStructure"
						           :init="loadData"
						           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
						           use-seeker seeker-url="/api/master/seeker/hardwaretype"
						           @refetch="(row)=>{rowLimit=row;getHardwareTypes()}"
						           @searching="(val)=>!val.status?getHardwareTypes():hardwaretypes=val.data"
						           @change-url="(url)=>getHardwareTypes(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">TYPES OF GOODS:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.hardware_type_name }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 mt-2 pt-0">
											<b-button v-b-modal.modal-edit-hardware-type class="btn btn-info mr-2"
											          v-on:click="selectedHardwareType=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</b-button>

										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.hardware_type_name }}</td>
							<td v-if="!isMobile">{{ obj.category }}</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-edit-hardware-type class="btn btn-info mr-2"
								          v-on:click="selectedHardwareType=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-hardware-type" title="Edit Hardware Type"
				         scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
					<b-container fluid v-if="!loadData&&hardwaretypes.length>0">
						<b-row class="mt-3 pt-1" v-if="hardwaretypes[selectedHardwareType]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">TYPES OF GOODS</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="hardwaretypes[selectedHardwareType].hardware_type_name"/>
							</b-col>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">CATEGORY <span style="color:red;">*</span></label>

								<!-- Pakai <select> dulu untuk debug -->
								<select
								v-model="hardwaretypes[selectedHardwareType].category"
								class="form-control w-100 rounded"
								name="category"
								>
								<option value="">-- Pilih Jenis --</option>
								<option v-for="opt in CategoryTypeOptions" :key="opt.value" :value="opt.value">
									{{ opt.label }}
								</option>
								</select>
							</div>
							<b-col cols="12" class="my-3 text-right" v-if="updateState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Successful update.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Update failed.
									</div>
								</div>
							</div>
							<b-col cols="12" class="my-3 text-right">
								<button class="btn btn-info" v-on:click="updateData">Simpan</button>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateUserState&&!updateState)?$bvModal.hide('modal-edit-hardware-type'):''">
								Tutup
							</b-button>
							<!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
						</div>
					</template>
				</b-modal>
				<modal-delete url="/api/master/hardwaretype/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Nama: {{ itemToDelete.hardware_type_name }}</li>
					</ul>
				</modal-delete>


			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			//step 1 edit
			dataEdit: null,
			deleteId: 0,
			createErrorMessage: "Gagal Menyimpan Tipe Perangkat Baru.",
			errorMessages: [],
			itemToDelete: {},
			hardwaretypes: [],
			searchValue: "",
			loadData: true,
			savingNewHardwareType: false,
			errorNewHardwareType: false,
			errorHardwareTypeList: [],
			errorSaved: false,
			existingClientResult: [],
			newHardwareTypeSaved: false,
			updateState: false,
			updateSaved: false,
			updateUserState: false,
			selectedHardwareType: 0,
			selectedTab: 0,
			updateClientCol: 6,
			newHardwareType: {
				hardware_type_name: "",
				category: "", 
			},
			CategoryTypeOptions: [
				{ label: "Aset", value: "Aset" },
				{ label: "Elektronik", value: "Elektronik" },
				{ label: "Stok", value: "Stok" },
				{ label: "Alat", value: "Alat" },
				{ label: "Umum", value: "Umum" },
				{ label: "Transmiter", value: "Transmiter" },
  				{ label: "Junction box", value: "Junction box" }
			],
			formHardwareTypeActive: false,
			hardwaretypeTableStructure: [
				//label: nama heading, key: nama object property
				{label: "NO", key: null},
				{label: "TYPES OF GOODS", key: null},
				{label: "CATEGORY", key: null},
				{label: "ACTION", key: null}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("hardware type page");
		this.getHardwareTypes();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/hardwaretype?limit=" + this.rowLimit + "&page=" + myParams;
			this.getHardwareTypes(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getHardwareTypes();
			}
		},
		getHardwareTypes(url = (this.$baseUrl + "/api/master/hardwaretype?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.hardwaretypes = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		// saveNewHardwareType() {
		// 	this.savingNewHardwareType = true;
		// 	this.errorNewHardwareType = false;
		// 	console.log(this.newHardwareType);
		// 	if (this.newHardwareType.hardware_type_name) {
		// 		axios.post(
		// 			this.$baseUrl + "/api/master/hardwaretype",
		// 			{
		// 				hardware_type_name: this.newHardwareType.hardware_type_name
		// 			},
		// 			{
		// 				"headers":
		// 					{
		// 						"Authorization": "Bearer " + localStorage.getItem("accessToken")
		// 					}
		// 			}
		// 		).then((result) => {
		// 			console.log(result);
		// 			if (result.status == 200) {
		// 				this.newHardwareType.hardware_type_name = "",
		// 					this.savingNewHardwareType = false;
		// 				this.newHardwareTypeSaved = true;
		// 				this.getHardwareTypes();
		// 			}
		// 			setTimeout(() => {
		// 				this.newHardwareTypeSaved = false;
		// 				this.formHardwareTypeActive = false;
		// 			}, 1000);

		// 		}).catch((err) => {
		// 			//check if token fail
		// 			if (err.response && err.response.status == 401) {
		// 				localStorage.removeItem("accessToken");
		// 				this.$router.push("/login");
		// 			}
		// 			console.log(err.response);
		// 			this.errorHardwareTypeList = [];
		// 			this.errorHardwareTypeList = Object.values(err.response.data.errors);
		// 			console.log(this.errorHardwareTypeList);
		// 			this.errorNewHardwareType = true;
		// 			this.savingNewHardwareType = false;
		// 		});
		// 	} else {
		// 		//pakai ini ary
		// 		this.errorNewHardwareType = true;
		// 		this.savingNewHardwareType = false;
		// 		this.errorHardwareTypeList = [];
		// 		if (this.newHardwareType.hardware_type_name == "") {
		// 			this.errorHardwareTypeList.push(["- Mohon isi Tipe Perangkat"]);
		// 		}
		// 		console.log(this.errorHardwareTypeList);
		// 	}
		// },
		saveNewHardwareType() {
			this.savingNewHardwareType = true;
			this.errorNewHardwareType = false;

			console.log("Submit Data:", this.newHardwareType);

			// Validasi sederhana
			if (!this.newHardwareType.hardware_type_name || !this.newHardwareType.category) {
				this.errorNewHardwareType = true;
				this.savingNewHardwareType = false;
				this.errorHardwareTypeList = [];

				if (!this.newHardwareType.hardware_type_name) {
				this.errorHardwareTypeList.push(["- Mohon isi Tipe Perangkat"]);
				}
				if (!this.newHardwareType.category) {
				this.errorHardwareTypeList.push(["- Mohon pilih Category"]);
				}
				return;
			}

			axios
				.post(
				this.$baseUrl + "/api/master/hardwaretype",
				{
					hardware_type_name: this.newHardwareType.hardware_type_name,
					category: this.newHardwareType.category,
				},
				{
					headers: {
					Authorization: "Bearer " + localStorage.getItem("accessToken"),
					},
				}
				)
				.then((result) => {
				if (result.status == 200) {
					this.newHardwareType.hardware_type_name = "";
					this.newHardwareType.category = "";
					this.savingNewHardwareType = false;
					this.newHardwareTypeSaved = true;
					this.getHardwareTypes();
				}
				setTimeout(() => {
					this.newHardwareTypeSaved = false;
					this.formHardwareTypeActive = false;
				}, 1000);
				})
				.catch((err) => {
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.errorHardwareTypeList = Object.values(err.response.data.errors || {});
				this.errorNewHardwareType = true;
				this.savingNewHardwareType = false;
				});
			},

				newUsernameChange() {
					this.newHardwareType.password = this.newHardwareType.username.toUpperCase();
				},
				deleteItem(item) {
					console.log("button delete untuk user id: " + item.id);
				},
				updateUserRoleValue(newValue) {
					this.newHardwareType.role = newValue;
				},
				setNewClientId(newId) {
					this.newHardwareType.clientId = newId;
					console.log(this.newHardwareType.clientId);
				},

			updateData() {
					console.log("updating data");
					this.updateState = true;
					axios.put(this.$baseUrl + "/api/master/hardwaretype/" + this.hardwaretypes[this.selectedHardwareType].id, {
						hardware_type_name: this.hardwaretypes[this.selectedHardwareType].hardware_type_name,
						category: this.hardwaretypes[this.selectedHardwareType].category,
						

					}, {
						"headers": {
									"Authorization": "Bearer " + localStorage.getItem("accessToken")
								}
							}).then((result) => {
						if (result.status == 200) {
							this.updateState = false;
							this.updateSaved = true;
							//step 4 edit
							this.dataEdit = this.hardwaretypes[this.selectedHardwareType];
							setTimeout(() => {
								this.updateSaved = false;
								this.$bvModal.hide("modal-edit-hardware-type");
							}, 1000);
							console.log("yaya berhasil");
						}
					}).catch((err) => {
						//check if token fail
						if (err.response && err.response.status == 401) {
							localStorage.removeItem("accessToken");
							this.$router.push("/login");
						}
						this.updateState = false;
						this.errorSaved = true;
						setTimeout(() => {
							this.errorSaved = false;
						}, 1000);
						console.log(err.response);
					});
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.hardwaretypes, this.selectedHardwareType, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updateUserState || this.updateClientState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-hardware-type");
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteUserState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		},

		deleteClientData() {
			console.log("deleting data");
			this.deleteUserState = true;
			axios.delete(this.$baseUrl + "/api/master/bank/" + this.users[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deleteUserState = false;
					this.userDeleted = true;
					this.users.splice(this.selectedToDelete, 1);

					setTimeout(() => {
						this.$bvModal.hide("modal-delete-user");
						this.userDeleted = false;
					}, 1500);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteUserState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1500);
				console.log(err);
			});
		}
	}
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

::v-deep .modal-content {
	margin: -3.25rem auto;
}
</style>
